import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import menuLinkModel from './menuLinkModel'

const {
  fetchAll,
  fetchOne,
  create,
  update,
  deleteOne,
  sorting,
} = useModelStoreModule(menuLinkModel)

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll,
    fetchOne,
    create,
    update,
    deleteOne,
    sorting,
  },
}
